import api from './apiSetup';

export const login = (email, password) => {
  return api('/auth', {
    method: 'POST',
    body: JSON.stringify({ email, password })
  });
};

export const refreshToken = () => {
  return api('/auth/refresh');
};

export const register = (first_name, last_name, email, password, password_confirmation) => {
  return api('/register', {
    method: 'POST',
    body: JSON.stringify({ first_name, last_name, email, password, password_confirmation })
  });
};

export const logout = () => api('/auth', { method: 'DELETE' });

export const forgotPassword = email =>
  api('/password', {
    method: 'POST',
    body: JSON.stringify({ email })
  });

export const resetPassword = (token, email, password, password_confirmation) =>
  api('/password/reset', {
    method: 'POST',
    body: JSON.stringify({ token, email, password, password_confirmation })
  });
